export default __webpack_public_path__ + "static/media/cabourg5.eebf40fe.jpg";